<template>
  <div class="mobile-personswiper-box">
    <!-- 人物轮播 -->
    <Swiper :teamList="teamList" />
    <!-- 下方图文 -->
    <div class="mobile-text">
      <div class="mobile-left">
        <span>Detial</span> <span>Passion</span> <span>Create</span>
        <span>Link</span> <span>Diversity</span> <span>Innovation</span>
      </div>
      <div class="mobile-right">
        <span>注重每一个细节</span> <span>充满无限热情和激情</span>
        <span>富有创造力</span> <span>连接品牌用户</span>
        <span>多元化工作方式</span> <span>保持努力创新</span>
        <span>敢于颠覆思想</span> <span>挑战给定解决方案</span>
        <span>只为脱颖而出</span> <span>创造独特数字体验</span>
      </div>
    </div>
    <!-- 图片 -->
    <img src="@/assets/mobile/team/banner2.png" alt="" class="mobile-pic" />
  </div>
</template>

<script>
import Swiper from "./components/Swiper";

export default {
  props: {
    teamList: {
      type: Array,
      default: () => [],
    },
  },
  components: { Swiper },
  data() {
    return {};
  },
};
</script>

<style scoped>
.mobile-personswiper-box .mobile-text {
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 6rem;
  padding-bottom: 2rem;
}

.mobile-personswiper-box .mobile-text span {
  display: block;
}

.mobile-personswiper-box .mobile-text .mobile-left {
  margin-left: 19.75rem;
  font-weight: 300;
  font-size: 1.625rem;
  color: #ffffff;
  line-height: 2.5rem;
}

.mobile-personswiper-box .mobile-text .mobile-right {
  font-weight: 300;
  font-size: 1.5rem;
  color: #ffffff;
  line-height: 2.5rem;
  margin-left: 3.0625rem;
  z-index: 2;
}

.mobile-personswiper-box .mobile-pic {
  z-index: 1;
}
</style>
